<template>
    <div class="quality-info">
      <div class="quality-type">
        <el-radio-group v-model="qualityType">
          <el-radio label="full">全检</el-radio>
          <el-radio label="partial">抽检</el-radio>
          <el-radio label="exempt">免检</el-radio>
        </el-radio-group>
      </div>
  
      <div class="quality-images">
        <div class="section-title">封样</div>
        <el-upload
          action="#"
          list-type="picture-card"
          :file-list="sealedSamples"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </div>
  
      <div class="quality-table">
        <el-table :data="qualityItems" border>
          <el-table-column label="质检项" prop="name"></el-table-column>
          <el-table-column label="质检内容" prop="content"></el-table-column>
          <el-table-column label="对照图" width="120">
            <template slot-scope="scope">
              <el-image 
                v-if="scope.row.image"
                :src="scope.row.image"
                :preview-src-list="[scope.row.image]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" @click="handleDeleteItem(scope.row)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <el-button type="text" icon="el-icon-plus" @click="handleAddItem">添加</el-button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'QualityInfo',
    data() {
      return {
        qualityType: 'full',
        sealedSamples: [],
        qualityItems: []
      }
    },
    methods: {
      handlePreview(file) {
        // 处理图片预览
      },
      handleRemove(file) {
        // 处理图片移除
      },
      handleDeleteItem(row) {
        // 处理删除质检项
      },
      handleAddItem() {
        // 处理添加质检项
      }
    }
  }
  </script>